import {setSubsidiary} from "./subsidiary";

document.addEventListener("DOMContentLoaded", function() {
    $(document).on('click', '.openMenuMobile', function () {
        if ($(this).hasClass('closed')) {
            $(this).removeClass('closed').addClass('opened');
            $(this).find('span').removeClass('text-dark dark:font-light').addClass('text-light-red font-normal')
            $(this).find('svg').attr('style', 'transform:rotate(180deg);')
            $(this).find('.fa-angle-right').removeClass('fa-angle-right').addClass('fa-angle-down');
            $(this).closest('.li_menu_top').find('.bx-nav-list-2-lvl').show();
        } else {
            $(this).removeClass('opened').addClass('closed');
            $(this).find('span').removeClass('text-light-red font-normal').addClass('text-dark dark:font-light')
            $(this).find('svg').removeAttr('style')
            $(this).find('.fa-angle-down').removeClass('fa-angle-down').addClass('fa-angle-right');
            $(this).closest('.li_menu_top').find('.bx-nav-list-2-lvl').hide();
        }

    });

    $('a.MenuHeader').on('click', function () {
        const boxMenu = $('.header_top#MenuHeader');
        boxMenu.toggleClass('hidden')
        if (boxMenu.hasClass('hidden')) {
            $('body').attr('style','overflow:auto');
            $(this).find('#icon').show()
            $(this).find('svg.close-svg').remove();
        } else {
            $('body').attr('style','overflow:hidden');
            $(this).find('#icon').hide()
            $(this).append('<svg width="23" height="23" viewBox="0 0 10 10" fill="none" class="close-svg" ' +
                ' xmlns="http://www.w3.org/2000/svg">' +
                '<path d="M0.833374 9.16669L9.08296 0.917114" stroke="white" stroke-width="1" ' +
                'stroke-linecap="round" stroke-linejoin="round"/>' +
                '<path d="M0.833374 0.833374L9.08296 9.08295" stroke="white" stroke-width="1" ' +
                'stroke-linecap="round" stroke-linejoin="round"/>' +
                '</svg>')
        }
    });

    let menu_items_array = undefined;
    const arrow = '<svg width="8" height="8" class="fill-[#9c9c9c] dark:fill-white" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<g clip-path="url(#clip0_678_2)">' +
        '<path fill-rule="evenodd" clip-rule="evenodd"' +
        ' d="M4.90932 20.0555C5.31423 20.4452 5.96977 20.4452 6.37365 20.0555L14.9369 11.7923C15.7457 11.0118 15.7457 9.74562 14.9369 8.96514L6.31151 0.640433C5.91074 0.254683 5.2635 0.249429 4.85755 0.630179C4.44331 1.01892 4.43814 1.65976 4.84616 2.0545L12.7404 9.67168C13.1453 10.0624 13.1453 10.695 12.7404 11.0857L4.90932 18.6424C4.50441 19.0321 4.50441 19.6657 4.90932 20.0555Z" ' +
        '/></g></svg>';

    function isMobileDevice() {
        return window.innerWidth < 1024;

        //header validation
        // return /Mobi|Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent);
    }
    if (isMobileDevice()) {
        $.ajax({
            url: '/local/templates/Oshisha/components/bitrix/menu/ajax.php?is_mobile=true',
            type: 'GET',
            success: function (response) {
                const menuHeader = document.getElementById('js-menu-upload');
                menuHeader.innerHTML = response;
                setSubsidiary()
            },
            error: function (xhr, status, error) {
                console.error('AJAX error: ' + status + ' - ' + error);
            }
        });
    }

    if  (window.innerWidth > 767) {
        setDesktopCatalog()
    }

    async function setDesktopCatalog() {
        if (document.getElementById('main_menus')) {
            await $.ajax({
                url: '/local/templates/Oshisha/components/bitrix/menu/ajax.php?is_mobile=false',
                type: 'GET',
                dataType: 'json',
                success: function (response) {
                    menu_items_array = response;
                },
                error: function (xhr, status, error) {
                    console.error('AJAX error: ' + status + ' - ' + error);
                }
            });
        }
    }

    $('#main_menus').on('click', function () {
        if (menu_items_array===undefined) {
            setDesktopCatalog().then(() => {
                showDesktopCatalog()
            })
            return
        }

        showDesktopCatalog()
    });

    $(document).on('click', '.child_js', function () {
        const that = $(this);
        const id = $(that).attr('id');
        const parentId = $(that).attr('data-parent-id');
        $('.menu_items_child').addClass('hidden').removeClass('flex');
        $('.menu_items_child .title').empty().html('<div class="js--back-menu cursor-pointer flex items-center absolute left-1 flex-row" ' +
            '><svg width="8" height="8" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<path fill-rule="evenodd" clip-rule="evenodd" ' +
            'd="M15.1338 0.292313C14.7289 -0.0974375 14.0734 -0.0974375 13.6695 0.292313L5.10657 8.5555C4.29781 9.33599 4.29781 10.6022 5.10657 11.3826L13.7317 19.7074C14.1324 20.0931 14.7796 20.0984 15.1856 19.7176C15.6008 19.3289 15.6049 18.688 15.1969 18.2933L7.30298 10.6761C6.89808 10.2854 6.89808 9.65278 7.30298 9.26204L15.1338 1.7054C15.5387 1.31565 15.5387 0.683053 15.1338 0.292313Z" ' +
            'class="fill-[#9c9c9c] dark:fill-white" /> ' +
            '</svg> ' +
            '<span class="text-xs text-dark dark:text-white dark:font-light font-normal ml-1"> Назад</span></div>'
            + '<span class="text-sm font-medium dark:font-normal text-dark dark:text-borderColor">' +
            '' + $(that).find('.text_catalog_link').text() + '</span></div>');

        $('.menu_items_child .title .js--back-menu').on('click', backToMenu)

        $('.menu_items_child .box .body').empty();
        $('.menu_items_child .box .title').empty();
        $('.menu_items').addClass('hidden').removeClass('flex');

        $('.menu_items_child .box .title').append('<div class="menu-item-line h-auto mb-3 px-2.5 w-1/2">' +
            '<a class="link_menu_header link_menu flex items-center justify-between" ' +
            'href="' + that.attr('data-href') + '" data-parent-id="'
            + parentId + '" data-href="' + that.attr('data-href') + '"> ' +
            '<span class="text_catalog_link text-sm text-hover-red dark:font-light' +
            ' dark:hover:text-white text-medium">' + 'Посмотреть все' + '</span></a>' +
            '</div>');

        $.each(menu_items_array.ELEMENT, function (key_item, value_parent) {
            if (parentId === key_item) {
                $.each(value_parent, function (key_child, value_item) {
                    if (id === key_child) {
                        createItemMenu(value_item.ELEMENT, $('.menu_items_child .box .body'), parentId, $('.menu_items_child'))
                    }
                });
            }
        });
        $('.menu_items_child').attr('style', 'min-height:' + $('.parent_menu').height() + 'px');
        $('.menu_items').attr('style', 'min-height:' + $('.parent_menu').height() + 'px');

    });

    $('.overlay_top').on('click', function () {
        closeMenu($('#main_menus'))
    });

    function showDesktopCatalog() {
        $('.overlay_top').show();

        const openButton = $(this).find('.span_bar');
        if (!openButton.hasClass('open_menu')) {
            $(this).attr('style', 'flex-direction:row;transition:0.3s;');
            openButton.addClass('open_menu')

            if (Object.keys(menu_items_array?.MAIN)?.length > 0) {
                let href = '';
                let name = '';
                $(menu_items_array.MAIN).each(function (key, value) {
                    let print_strelka = '';
                    let class_active = '';

                    if (value.TEXT === 'Кальянные смеси') {
                        class_active = 'active_item_menu bg-[#ffffff82] dark:bg-grayButton';
                        href = value.TEXT;
                        name = 'Кальянные смеси'
                    }

                    if (value.HAS_CHILD == 1)
                        print_strelka = '<svg width="12" height="12" class="ml-2" viewBox="0 0 21 21" fill="none" ' +
                            'xmlns="http://www.w3.org/2000/svg">' +
                            '<g clip-path="url(#clip0_678_2)">' +
                            '<path fill-rule="evenodd" clip-rule="evenodd" ' +
                            'd="M4.90932 20.0555C5.31423 20.4452 5.96977 20.4452 6.37365 20.0555L14.9369 11.7923C15.7457 11.0118 15.7457 9.74562 14.9369 8.96514L6.31151 0.640433C5.91074 0.254683 5.2635 0.249429 4.85755 0.630179C4.44331 1.01892 4.43814 1.65976 4.84616 2.0545L12.7404 9.67168C13.1453 10.0624 13.1453 10.695 12.7404 11.0857L4.90932 18.6424C4.50441 19.0321 4.50441 19.6657 4.90932 20.0555Z" ' +
                            'fill="#9c9c9c"></path></g></svg>';

                    if (value.LINK !== '' && value.LINK !== null && value.TEXT !== '' && value.TEXT !== null
                        && value.TEXT !== ' ') {
                        $('.parent_menu').append('<li class="li_menu_header p-3 flex flex-row w-full items-center ' +
                            'justify-between link_js ' + class_active + '" ' +
                            'data-role="bx-menu-item" data-href="' + value.LINK + '"> ' +
                            '<a class="link_menu_header parent_category" id="' + value.ID
                            + (value.HAS_CHILD == 0 ? '"href="' + value.LINK + '">' : '" href="javascript:void(0)">') +
                            '<span class="text_catalog_link text-base font-medium text-dark ' +
                            'dark:text-borderColor hover:text-hover-red dark:font-normal dark:hover:text-white ' +
                            'flex flex-row items-center">' +
                            '<svg width="40" height="16" viewBox="0 0 60 36" fill="none" class="mr-3" ' +
                            'xmlns="http://www.w3.org/2000/svg">' +
                            '<path d="M59.2924 2.38227C58.8456 2.20106 58.1322 1.82441 57.282 1.59762C56.4318 1.35773 55.2831 0.958853 54.1115 0.858564C52.928 0.734913 51.5901 0.698444 50.1279 0.769102C48.7005 0.885346 47.2514 1.18849 45.6975 1.59022C44.1453 1.9908 42.7253 2.65749 41.2085 3.38687C39.7281 4.14131 38.3787 5.08266 37.0277 6.10777C35.7507 7.1665 34.5393 8.33862 33.4315 9.58482C32.3985 10.8652 31.3716 12.1826 30.5807 13.5884C29.7653 14.9845 29.0621 16.4221 28.5533 17.8923C27.4649 20.8029 27.0313 23.7979 26.9857 26.4652C26.9897 27.8186 27.0695 29.0744 27.237 30.2283C27.3835 31.3754 27.6706 32.4341 27.8923 33.29C27.9818 33.6917 28.1077 34.0758 28.2319 34.4154C28.4502 33.9573 28.6872 33.474 28.9516 32.9453C30.265 30.34 32.1796 26.9473 34.4185 23.77C35.5336 22.179 36.757 20.6662 37.9497 19.2986C38.5816 18.6416 39.1924 18.0096 39.7691 17.4102C40.3891 16.8535 40.9743 16.3258 41.5105 15.8403C42.0923 15.4033 42.6222 15.0055 43.094 14.6511C43.5465 14.2756 44.02 14.0574 44.375 13.8317C45.0987 13.4032 45.5118 13.1587 45.5118 13.1587C45.5118 13.1587 45.118 13.4368 44.4314 13.9178C44.0975 14.173 43.649 14.4209 43.2279 14.8283C42.7914 15.2135 42.2997 15.6472 41.7618 16.1201C41.2689 16.6421 40.7361 17.2022 40.1725 17.7971C39.654 18.429 39.1058 19.0957 38.5406 19.7863C37.4739 21.2234 36.4015 22.791 35.4362 24.4332C33.4925 27.7029 31.8902 31.1611 30.8121 33.7931C30.5089 34.5345 30.2536 35.1972 30.0343 35.7824C30.4958 35.6593 31.0822 35.5288 31.7147 35.2952C32.517 35.0166 33.5529 34.7294 34.5569 34.3197C35.5849 33.9265 36.6807 33.4621 37.7861 32.9333C38.9092 32.4125 40.0033 31.8005 41.1241 31.1566C42.2438 30.5155 43.3043 29.7822 44.3579 29.0277C45.3813 28.2436 46.3973 27.4516 47.3193 26.5746C48.2304 25.6732 49.1507 24.8276 49.9461 23.8503C51.5821 21.9762 52.9759 19.9715 54.1115 17.8558C54.7024 16.8592 55.1936 15.699 55.6751 14.6505C56.1623 13.61 56.576 12.4556 56.988 11.3969C57.4034 10.3575 57.7875 9.30447 58.1265 8.27879C58.4952 7.22234 58.8171 6.30151 59.0844 5.54478C59.3926 4.79205 59.5852 4.00512 59.759 3.54186C59.9192 3.01876 60.0012 2.7424 60.0012 2.7424C60.0012 2.7424 59.7528 2.59196 59.2924 2.38227Z"' +
                            ' class="fill-light-red"></path> ' +
                            '<path d="M23.0374 25.802C21.4464 24.6863 19.9353 23.4623 18.5671 22.2685C17.9118 21.6406 17.2793 21.028 16.6787 20.4514C16.1209 19.8314 15.5966 19.2462 15.1072 18.71C14.6712 18.1305 14.2746 17.596 13.9185 17.1265C13.543 16.6735 13.3276 16.2005 13.1002 15.8455C12.6706 15.1235 12.4267 14.7087 12.4267 14.7087C12.4267 14.7087 12.7048 15.1025 13.188 15.7891C13.4393 16.1224 13.6889 16.5703 14.0986 16.9914C14.4838 17.4296 14.9168 17.9214 15.3904 18.4593C15.9112 18.9505 16.4725 19.485 17.0673 20.0462C17.6981 20.5648 18.3671 21.113 19.0566 21.6782C20.492 22.7409 22.0613 23.8173 23.7024 24.7826C24.3816 25.1883 25.0699 25.545 25.756 25.9114C25.9828 22.2418 26.7361 18.6143 27.8638 15.3105C27.2176 14.4751 26.5623 13.6528 25.8415 12.9001C24.9406 11.9872 24.0984 11.067 23.1177 10.2727C21.2424 8.63669 19.2401 7.24348 17.1249 6.10611C16.1283 5.51521 14.9664 5.02402 13.9179 4.54309C12.8797 4.05589 11.7264 3.64049 10.6671 3.23079C9.62661 2.8171 8.57472 2.43418 7.5479 2.09513C6.49202 1.72361 5.57346 1.40166 4.81389 1.13441C4.06116 0.827849 3.27252 0.63354 2.81097 0.459744C2.29015 0.301903 2.01265 0.21814 2.01265 0.21814C2.01265 0.21814 1.85822 0.469432 1.64682 0.929278C1.46733 1.37488 1.0901 2.08944 0.862174 2.93961C0.623419 3.78694 0.223403 4.93627 0.125964 6.10839C3.31858e-05 7.29305 -0.0358656 8.6327 0.0365018 10.0943C0.149327 11.5206 0.451902 12.9673 0.854766 14.5235C1.2582 16.0746 1.92318 17.4963 2.65142 19.0143C3.407 20.4907 4.34721 21.84 5.37574 23.1934C6.4339 24.4726 7.60602 25.6835 8.85165 26.7929C10.1298 27.8226 11.45 28.85 12.8581 29.6438C14.2513 30.4592 15.6895 31.1629 17.1591 31.67C20.0686 32.7601 23.0636 33.1932 25.7332 33.2399C25.8472 33.2399 25.9446 33.2279 26.0529 33.2245C25.7674 31.3544 25.6637 29.4455 25.699 27.5286C24.8129 26.9719 23.9229 26.426 23.0374 25.802Z" ' +
                            'class="fill-light-red dark:fill-dark-red">' +
                            '</path> </svg>' +
                            '' + value.TEXT + '</span></a>' + print_strelka + '</li>');
                    }
                });
                $('.menu_items .title').empty().html(name +
                    ` <div class="sendToCategoryMain cursor-pointer flex items-center absolute right-1" ` +
                    `onclick="location.href=\'' + href + '\'">
                    <span class="text-xs text-dark dark:text-white dark:font-light font-normal mr-1">Все</span> ${arrow}</div>`);

                $.each(menu_items_array.ELEMENT, function (key_item, value_item) {
                    $('.parent_menu').find('li.active_item_menu').each(
                        function () {
                            if ($(this).find('a').attr('id') === key_item) {
                                createItemMenu(value_item, $('.menu_items .box'), key_item)
                            }
                        }
                    );
                });
            }
            $('#main_menu').removeClass('hidden').addClass('flex').show(300);
            $('.menu_items_child').attr('style', 'min-height:' + $('.parent_menu').height() + 'px');
            $('.menu_items').attr('style', 'min-height:' + $('.parent_menu').height() + 'px');
        } else {
            closeMenu($(this))
        }

        $(document).on('click', 'li.link_js', function () {
            const li = $(this).closest('li')
            const id = li.find('a').attr('id');

            $(document).find('.active_item_menu').removeClass('active_item_menu').removeClass('bg-[#ffffff82] dark:bg-grayButton');
            li.addClass('active_item_menu').addClass('bg-[#ffffff82] dark:bg-grayButton');

            $('.menu_items').addClass('hidden').removeClass('flex');
            $('.menu_items .title').empty().html(
                $(li).find('.text_catalog_link').text() +
                '<div class="sendToCategoryMain cursor-pointer flex items-center absolute right-1" ' +
                'onclick="location.href=\'' + li.attr('data-href') + '\'">' +
                '<span class="text-xs text-dark dark:text-white dark:font-light font-normal mr-1"> Все </span> ' + arrow + '</div>');

            $('.menu_items .box').empty();
            $('.menu_items_child').addClass('hidden').removeClass('flex');
            $.each(menu_items_array.ELEMENT, function (key_item, value_item) {
                if (id === key_item) {
                    createItemMenu(value_item, $('.menu_items .box'), id, $('.menu_items'))
                }
            });
            $('.menu_items_child').attr('style', 'min-height:' + $('.parent_menu').height() + 'px');
            $('.menu_items').attr('style', 'min-height:' + $('.parent_menu').height() + 'px');
        });
    }
    function backToMenu() {
        const child = document.querySelector('.menu_items_child');
        if (child) {
            child.classList.add('hidden');
            child.classList.remove('flex');
        }

        const items = document.querySelector('.menu_items');
        if (items) {
            items.classList.remove('hidden');
            items.classList.add('flex');
        }
    }

    function closeMenu(icon_bar) {
        $(icon_bar).removeAttr('style');
        $(icon_bar).find('.span_bar').removeClass('open_menu');
        $('#main_menu').hide(300).addClass('hidden').removeClass('flex');
        $('.parent_menu').empty();
        $('.menu_items .box').empty();
        $('.menu_items .title').empty();
        $('.menu_items_child .box .body').empty();
        $('.menu_items_child .box .title').empty();
        $('.menu_items_child .title').empty();
        $('.overlay_top').hide();
    }

    function createItemMenu(value_item, menu_items, parentId = 0, parent) {

        let res = Object.entries(value_item).sort((a, b) => {
            if (a[1].TEXT < b[1].TEXT) return -1;
            if (a[1].TEXT > b[1].TEXT) return 1;
            return 0;
        });

        let listLength = res.length;
        let classItem = 'w-1/2';
        const maxLength = 14;
        let isLengthWholeNumber = true;

        if (res.length > maxLength) {
            isLengthWholeNumber = (res.length / 2) % 1 === 0
            listLength = Math.ceil(res.length / 2);
            classItem = 'w-1/2';
        }

        for (let i = 0; i < listLength; i++) {

            let itemList = res[i]
            createItem(itemList, menu_items, parentId, classItem)

            if (res.length > maxLength) {
                let newIndex = (Math.floor(res.length / 2) + i) + (isLengthWholeNumber ? 0 : 1);
                if ((res.length - 1) >= newIndex) {
                    itemList = res[newIndex];
                    createItem(itemList, menu_items, parentId, classItem)
                }
            }
        }

        $(parent).removeClass('hidden').addClass('flex');
    }

    function createItem(itemList, menu_items, parentId, classItem) {
        let down = '';
        let classChild = '';
        let val = itemList[1];
        let href = val?.LINK;
        if (typeof val.ELEMENT === "object" && Object.keys(val.ELEMENT)?.length > 0) {
            down = '<div class="p-1.5 bg-filterGray dark:bg-grayButton rounded-full">' + arrow + '</div>';
            classChild = 'child_js';
            href = 'javascript:void(0)'
        }
        let item = '<div class="menu-item-line h-auto mb-3 px-2.5 ' + classItem + '">' +
            '<a class="link_menu_header link_menu flex items-center justify-between  ' + classChild + '" ' +
            'href="' + href + '" data-parent-id="' + parentId + '" id="' + itemList[0] + '" data-href="' + val?.LINK + '"> ' +
            '<span class="text_catalog_link text-sm text-dark dark:font-light' +
            ' dark:text-borderColor dark:hover:text-white text-medium hover:text-hover-red">' + val.TEXT + '</span> ' + down + ' </a>' +
            '</div>';

        $(menu_items).append(item)
    }

});




